module.exports = __webpack_public_path__ + "static/media/cap3-03-desk.28d50658.jpg";